module.exports = __webpack_public_path__ + "img/Avitseron_1280x1010.1cce10ca.jpg";